import EmptyState from '../components/EmptyState';

export default function News() {
  return (
    <EmptyState
      title="News"
      description="Headlines and source-linked news content"
      phase={5}
    />
  );
}
